module.exports = __webpack_public_path__ + "img/code2.6c5c17f0.jpeg";